const getDefaultState = () => {
    return {
        history: [],
        emitList: {
            'co-browsing-request': 'emitCoBrowsingRequest',
            message: 'emitSocketGetMessage',
            reload: 'emitSocketReload',
            'need-update-widget': 'emitSocketNeedUpdateWidget',
            'contacts-request': 'emitSocketContactsRequest',
            'rating-request': 'emitSocketRatingRequest',
            'update-active-chat-id': 'emitSocketUpdateActiveChatId',
            'guest-redirect': 'emitSocketGuestRedirect',
            'finished-branch-work-time': 'emitFinishedBranchWorkTime',
            'update-guest-employee': 'emitUpdateGuestEmployee'
        }
    }
}
// initial state
const state = getDefaultState()

export default {
    namespaced: true,
    state,
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        historyPush(state, val) {
            //console.log('socket historyPush',val);
            state.history.push(val)
            //state.messages.push(state.messagesTemp)
        },
        historyClear(state) {
            //console.log('socket historyPush',val);
            state.history = state.history.slice(state.history.length - 20, state.history.length)
            //state.messages.push(state.messagesTemp)
        }
    },
    actions: {},
    getters: {}
}
